import { View, html, CustomEventWithoutDetail, on, rune, $ as $E } from 'rune-ts';
import klass from './PlusShopEditor.module.scss';
import { CloseIcon } from '../../../../../shared/components/atoms/Icon';
import { typo, typoPcMo } from '../../../../../shared/typography/typo';
import { PlusShopEditorController } from './PlusShopEditorController';
import { PlusShopEditorText } from './PlusShopEditorText';
import axios from 'axios';
import { AdScriptGaF } from '../../../../../../../modules/AdScript/Ga/F/Function/module/AdScriptGaF';
import { Alert } from '../../../../../shared/components/cells/Alert/Alert';
import { loading, loadingEnd } from '../../../../../shared/client/global';
import { ButtonRadio } from '../../../../components/atoms/ButtonRadio/ButtonRadio';
import { LandingTextarea } from '../../../../components/cells/LandingTextarea/LandingTextarea';
import { MShopUtilF } from '../../../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import { getResizedUrl } from '../../../../../shared/util/image';

export class PlusShopEditorClosed extends CustomEventWithoutDetail {}

export class PlusShopEditor extends View {
  private _formController: PlusShopEditorController;
  is_valid = false;

  constructor(props) {
    super(props);

    this._formController = new PlusShopEditorController(this);
  }

  protected override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = new PlusShopEditorText().getTexts(is_mobile);

    return html`
      <div class="${klass.container}" data-valid="${this.is_valid}">
        <div class="${klass.bg_image}">
          <img
            class="${klass.image}"
            src="${getResizedUrl({
              url: '/s3.marpple.co/files/u_14345/2024/6/original/plus/section1/mo-plus.png',
              width: 1920 * 2,
              format: 'webp',
              quality: 85,
            })}"
            alt="플러스샵 모션 이미지"
          />
        </div>
        <div class="${klass.bg}"></div>

        <div class="${klass.content_wrapper}">
          <div class="${klass.close_wrapper}">
            <div class="${klass.close_button}">${CloseIcon}</div>
          </div>

          <div class="${klass.content}">
            <div
              class="${klass.sub_title} ${typoPcMo({
                is_mobile,
                pc: '16_medium',
                mo: '14_medium',
              })}"
            >
              MarppleShop Plus
            </div>
            <div
              class="${klass.title} ${typoPcMo({
                is_mobile,
                pc: '48_bold',
                mo: '28_bold',
              })}"
            >
              ${texts.submit_form_title}
            </div>
            <div
              class="${klass.description} ${typoPcMo({
                is_mobile,
                pc: '20_medium',
                mo: '14_medium',
              })}"
            >
              ${texts.submit_form_description}
            </div>
            <form class="${klass.input_form}">
              <div class="${klass.input_row}">
                ${this._formController.inputCompany}${this._formController.inputCompanyCategory}
              </div>
              <div class="${klass.input_row}">
                ${this._formController.inputManager} ${this._formController.inputManagerEmail}
                ${this._formController.inputManagerPhone}
              </div>
              <div class="${klass.input_row}">${this._formController.inputFile}</div>
              <div class="${klass.input_row}">
                ${is_mobile
                  ? new LandingTextarea({
                      name: 'body',
                      placeholder: texts.submit_form_other,
                      rows: 2,
                    })
                  : this._formController.inputOther}
              </div>
              <div class="${klass.guide} ${typo('12_medium')}">${texts.submit_form_guide}</div>
            </form>
            <div class="${klass.agree} ${typo('16_medium')}">
              ${new ButtonRadio({
                label: texts.submit_form_agree,
                name: 'agree',
                wrapper_klass: klass.agree_button,
                active: this._formController.is_agree,
                value: `${this._formController.is_agree}`,
              })}
              <div class="${klass.agree_content} ${typo('12_medium')}">
                ${html.preventEscape(texts.submit_form_agree_content)}
              </div>
            </div>
            <div class="${klass.marketing}">
              ${new ButtonRadio({
                label: texts.submit_form_marketing,
                name: 'marketing',
                wrapper_klass: klass.agree_button,
                active: this._formController.is_marketing,
                value: `${this._formController.is_marketing}`,
              })}
              <div class="${klass.agree_content} ${typo('12_medium')}">
                ${html.preventEscape(texts.submit_form_marketing_content)}
              </div>
            </div>
          </div>
          <div class="${klass.button_wrapper}">${this._formController.submitButton}</div>
        </div>
      </div>
    `;
  }

  @on('click', `.${klass.close_button}`)
  onClickCloseButton() {
    this.element().remove();
    this.dispatchEvent(PlusShopEditorClosed, { bubbles: true });
  }

  @on('click', `.${klass.agree} .${klass.agree_button}`)
  onClickAgreeButton() {
    this._formController.is_agree = !this._formController.is_agree;
    this.redraw();
    this._formController.setValidationInHtml();
  }

  @on('click', `.${klass.marketing} .${klass.agree_button}`)
  onClickMarketingButton() {
    this._formController.is_marketing = !this._formController.is_marketing;
    this.redraw();
    this._formController.setValidationInHtml();
  }

  @on('click', `.${klass.submit}`)
  async onClickSubmitButton() {
    const is_valid = await this._formController.isValidInputFormWithModal();

    if (is_valid) {
      loading();
      const {
        data: { id },
      } = await axios.post('/@api/plus/application', {
        company_name: this.getValue('company_name'),
        name: this.getValue('manager_name'),
        type: this.getValue('company_category'),
        email: this.getValue('manager_email'),
        mobile: this.getValue('manager_phone'),
        file_url: this._formController.inputFile.file?.url,
        is_marketing_agree: this._formController.is_marketing,
        body: this.getValue('body') || ' ',
      });
      loadingEnd();

      if (id) {
        await Alert.open({
          title: ET('mps2::landing::plus::submit_success_modal_title'),
          message: html.preventEscape(ET('mps2::landing::plus::submit_success_modal')),
        });
        AdScriptGaF.applyPlus();
        this.onClickCloseButton();
        document.querySelector('html, body')?.scrollTo(0, 0);
      } else {
        await Alert.open({
          title: ET('mps2::landing::plus::submit_fail_modal_title'),
          message: html.preventEscape(ET('mps2::landing::plus::submit_fail_modal')),
        });
      }
    }
  }

  override redraw() {
    const text_area_value = this.element().querySelector('textarea')?.value || '';
    const text_area_scroll_y = this.element().querySelector('textarea')?.scrollTop || 0;
    const content_wrapper_scroll_y =
      this.element().querySelector(`.${klass.content_wrapper}`)?.scrollTop || 0;
    const scroll_y = window.scrollY;

    super.redraw();

    const text_area = this.element().querySelector('textarea');
    const content_wrapper = this.element().querySelector(`.${klass.content_wrapper}`);

    if (text_area) {
      text_area.value = text_area_value;
      text_area.scrollTo(0, text_area_scroll_y);
    }
    this.subView(LandingTextarea)?.setAutoHeightInTextArea();

    if (content_wrapper) {
      content_wrapper.scrollTo(0, content_wrapper_scroll_y);
    }

    window.scrollTo(0, scroll_y);

    return this;
  }

  override onRender() {
    if (MShopUtilF.isIOS()) {
      window.addEventListener(
        'scroll',
        (e: Event) => {
          this.forceWindowScrollIntoViewport(e);
        },
        { passive: false },
      );

      const input_file_label = this._formController.inputFile.element().querySelector('label');

      if (input_file_label) {
        input_file_label.addEventListener('click', (e: Event) => {
          this.forceWindowScrollIntoViewport(e);
        });
      }
    }
  }

  // 가상 영역까지 스크롤 내려가는 것을 방지
  forceWindowScrollIntoViewport(e: Event) {
    if (
      visualViewport &&
      visualViewport.height > window.innerHeight &&
      window.scrollY + visualViewport.height > this.element().offsetHeight - 2
    ) {
      e.preventDefault();
      window.scrollTo(0, this.element().offsetHeight - visualViewport.height - 1);
    }
  }

  setIsValid(valid: boolean) {
    this.is_valid = valid;
    this.element().dataset.valid = `${valid}`;
  }

  getValue(name: string) {
    return $E(this.element()).find(`input[name="${name}"], textarea`)?.getValue() || '';
  }
}
